import React, { useState } from 'react';
import { map } from 'rxjs/operators';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getProtocolAuoCompleteApi } from 'actions/packet';
import TypeAhead from './TypeAhead';

const fetchData = (context, searchText) => bindLogger(
  getProtocolAuoCompleteApi,
  context
)(searchText)().pipe(
  map((resp) => {
    const { response } = resp;
    if (response != null && response.length > 0) {
      return response.map((r) => ({
        label: r,
        value: r
      }));
    }
    return [];
  })
);

function ProtocolTypeahead({ context, onChange, value }) {
  const [options, setOptions] = useState([]);

  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setOptions([]);
      return;
    }
    fetchData(context, searchText).subscribe(setOptions);
  };

  return <TypeAhead name="Protocol" value={value} options={options} onChange={onChange} onChangeText={fetchOptions} />;
}

export default withAppContext(ProtocolTypeahead);
